<template class='body-section'>
  <div>
    <v-overlay v-model="loading" opacity='0.9' color='rgba(255, 255, 255 , 1)'>
      <v-img src='https://www.myq.gr/ext_files/prepaid/q/media/loading_orange.gif'></v-img>
    </v-overlay>
    <v-dialog v-model="dialog" opacity='0.9' color='rgba(255, 255, 255 , 1)' width="30vw">
      <v-card class="text-center">
        <h3 class="pa-8">{{dialogMessage}}</h3>
      </v-card>
    </v-dialog>
    <v-container>
        <div class="d-flex flex-row justify-center">
          <v-card elevation=0 color='transparent'>
          <!-- centered v-image with logo.png -->
          
          <v-img
            class="mt-12 mx-auto"
            src="/ext_files/prepaid/q/media/koneLogo-orange.png"
            max-width="400"
          />
          <div v-if="!getReward">
            <div class="center-blue-text mt-5">
                {{getMessages['raf.frienddashboard.steptowin']}}
                <!-- Ένα μόνο βήμα μένει για να κερδίσετε -->
            </div>
            <div class="orange-under-title">
              <!-- 12GB για 12 μήνες -->
              {{contentList.segmentOffer}}
            </div>
            <div class="small-orange-under-title">
                {{getMessages['raf.frienddashboard.youandfriend']}}
                <!-- εσύ και ο φίλος σου -->
            </div>
            <v-row class='justify-center'>
              <v-col class='justify-center'>
                <v-card width="300" height="170" class="mx-auto justify-center" elevation=0 color='#FFF9F0' rounded=xl>
                  <div class="social-tab text-center">
                      <div class="orange-intab-title">
                        {{getMessages['raf.frienddashboard.doyouwant']}}
                        <!-- Θέλεις  -->
                        <span class="black-title">
                          {{getMessages['raf.frienddashboard.qcard']}}
                          <!-- κάρτα Q; -->
                          </span></div>
                      <v-btn :href="$store.getters.getLocale === 'gr' ? '/gr/ela-stin-q/online-paraggelia/' : '/en/switch-to-q/online-order/'" target='_blank' elevation='0' small class="white--text px-10 py-5" color="#F54D23" rounded>
                      {{getMessages['raf.frienddashboard.ordercard']}}
                      <!-- Παραγγειλέ την online εδώ -->
                      </v-btn>
                      <div class="small-text mt-2">
                          {{getMessages['raf.frienddashboard.findstore']}} 
                          <!-- ή βρες ένα κατάστημα WIND  -->
                          <a :href="$store.getters.getLocale === 'gr' ? '/gr/upostirixi/katastimata/' : '/en/support/stores/'" target='_blank'>
                            {{getMessages['raf.frienddashboard.here']}}
                            <!-- εδώ -->
                          </a>
                      </div>
                  </div>
                </v-card>
              </v-col>
              <v-col class='justify-center'>
                <v-card width="300" height="170" class="justify-center mx-auto" elevation=0 color='#FFF9F0' rounded=xl>
                  <div class="social-tab text-center">
                    <div class="blue-title text-center">
                      {{getMessages['raf.frienddashboard.yougot']}} 
                      <!-- Πήρες -->
                      <span class="black-title">
                        {{getMessages['raf.frienddashboard.qcard']}}
                        <!-- κάρτα Q; -->
                      </span></div>
                    <v-btn elevation='0' href="#" @click="goToReward" small class="white--text px-10 py-5" color="#0E28B8" rounded>
                      {{getMessages['raf.frienddashboard.gotogift']}}
                      <!-- Προχώρησε για δώρο -->
                    </v-btn>
                  </div>
                </v-card>
              </v-col>
            </v-row>
            <div class="text-center mt-8">
            <div class="centered-black-title">
              {{getMessages['raf.frienddashboard.learnmore']}}
              <!-- Τι άλλο θέλεις να μάθεις; -->
            </div>
              <v-btn :href="'https://www.myq.gr/'+$store.getters.getLocale+'/support/paketa-ipiresies/ti-ine-to-q-kone'" target='_blank' elevation='0' class="px-10 py-5" small color="#3FD3D0" rounded>
                <strong>
                  {{getMessages['raf.frienddashboard.findhere']}}
                  <!-- Βρες το εδώ -->
                </strong>
              </v-btn>
              <div class="terms-conditions text-center">
                  {{getMessages['raf.frienddashboard.termstext']}}
                  <!-- Διάβασε περισσότερα στους  -->
                  <a :href="$store.getters.getTermsUrl" target="_blank">
                    {{getMessages['raf.frienddashboard.termslink']}}
                    <!-- Όρους και προυποθέσεις -->
                  </a>
              </div>
            </div>
          </div>
          <div v-else>
            <v-card v-if="!success" width="900" class="d-flex justify-center mt-5 pb-5 kone-pairing-card" elevation='0' color='#FFF9F0' rounded='xl'>
                <div class="text-center">
                  <v-img
                    class="mx-auto mt-8"
                    src="/ext_files/prepaid/q/media/check-circle.png"
                    max-width="50"
                  />
                  <div class="centered-orange-title mt-3">
                    {{getMessages['raf.frienddashboard.addphone']}}
                    <!-- Τέλεια! Συμπλήρωσε τον αριθμό σου για να πάρετε το δώρο σας! -->
                  </div>
                  <v-form v-model="valid">
                    <v-text-field :rules='msisdnRules' v-model="msisdn" type="tel" :placeholder="getMessages['raf.frienddashboard.inputphone']" rounded outlined dense class="mt-8 mx-6"></v-text-field>
                    <!-- Βάλε τον Q αριθμό σου -->
                  </v-form>
                  <v-btn @click="finalizeInvitation" class="white--text mt-8 px-14 py-6" color="#F54D23" rounded>{{getMessages['raf.frienddashboard.getgift']}}</v-btn>
                  <!-- Πάρε το δώρο σου -->
                  <v-card v-if="dialogMessage.length > 10" class='mx-5 mt-5 text-center' color='#FFBEA2' elevation='0' rounded='pill'>
                        <div class="valuation-text">
                            <!-- {{getMessages['raf.landing.confirmation']}} -->
                            {{ dialogMessage }}
                        </div>
                    </v-card>
                </div>
            </v-card>
            <v-card v-else width="900" class="d-flex justify-center mt-5 pb-5 kone-pairing-card" elevation='0' color='#FFF9F0' rounded='xl'>
              <div class="text-center">
                <v-img
                  class="mx-auto mt-8"
                  src="/ext_files/prepaid/q/media/check-circle.png"
                  max-width="50"
                />
                <div class="centered-orange-title mt-3">
                  {{getMessages['raf.frienddashboard.super']}}
                  <!-- Σούπερ! -->
                </div>
                <div class="centered-orange-title mt-3">
                  <!-- {{getMessages['raf.frienddashboard.addphone']}} -->
                  {{successMessage}}
                </div>
                <v-btn @click="getReward = false" class="white--text mt-8 px-14 py-6" color="#F54D23" rounded>Κλείσιμο</v-btn>  
              </div>
            </v-card>
            <v-card class="mx-auto mt-8" color='transparent' elevation=0 width="800">
              <div class="center-under-title">{{getMessages['raf.frienddashboard.beforenumber']}}</div>
              <!-- Πριν βάλεις τον αριθμό σου: -->
            <v-row justify="center">
              <v-col cols='12' sm='12' md='6' lg='6' class="text-left pa-1">
                <v-card elevation=0 color="transparent" class="d-flex justify-left">
                  <v-img contain class="pa-2 mr-2" fixed width="10" max-width="10" src="/ext_files/prepaid/q/media/ul-check.png">
                  </v-img>
                  <span class="small-txt">
                    {{getMessages['raf.frienddashboard.requirement1']}}
                    <!-- Τον ενεργοποίησες μέσα στις τελευταίες 15 ημέρες; -->
                  </span>
                  </v-card>
              </v-col>
              <v-col cols='12' sm='12' md='6' lg='6' class="text-left pa-1"><v-card elevation=0 color="transparent" class="d-flex justify-left">
                  <v-img contain class="pa-2 mr-2" fixed width="10" max-width="10" src="/ext_files/prepaid/q/media/ul-check.png">
                  </v-img>
                  <span class="small-txt">
                    {{getMessages['raf.frienddashboard.requirement2']}}
                    <!-- Είναι ο φίλος σου πάνω από ένα μήνα χρήστης Q; -->
                  </span>
                  </v-card></v-col>
            </v-row>
            <v-row justify="center">
              <v-col cols='12' sm='12' md='6' lg='6' class="text-left pa-1"><v-card elevation=0 color="transparent" class="d-flex justify-left">
                  <v-img contain class="pa-2 mr-2" fixed width="10" max-width="10" src="/ext_files/prepaid/q/media/ul-check.png">
                  </v-img>
                  <span class="small-txt">
                    {{getMessages['raf.frienddashboard.requirement3']}}
                    <!-- Εσύ και ο φίλος σου έχετε κάνει ανανέωση με 10€; -->
                  </span>
                  </v-card></v-col>
              <v-col cols='12' sm='12' md='6' lg='6' class="text-left pa-1"><v-card elevation=0 color="transparent" class="d-flex justify-left">
                  <v-img contain class="pa-2 mr-2" fixed width="10" max-width="10" src="/ext_files/prepaid/q/media/ul-check.png">
                  </v-img>
                  <span class="small-txt">
                    {{getMessages['raf.frienddashboard.requirement4']}}
                    <!-- Έχεις υπόλοιπο πάνω από 0,01€; -->
                  </span>
                  </v-card></v-col>
            </v-row>
            </v-card>
          </div>
          </v-card>
        </div>
    </v-container>
  </div>
</template>

<script>

import axios from 'axios';
import { mapGetters } from 'vuex'

// prevent user from pressing the back button
window.addEventListener("hashchange", function(e) {
  if (document.getElementById('app').__vue__.$children[1].$children[0].pushes === 2) {
    document.getElementById('app').__vue__.$children[1].$children[0].getReward = false
    document.getElementById('app').__vue__.$children[1].$children[0].pushes = 0
  }
  if (document.getElementById('app').__vue__.$children[1].$children[0].pushes === 1) {
    document.getElementById('app').__vue__.$children[1].$children[0].pushes = 2
  }
})

export default {
  name: 'FriendDashboard',

  components: {

  },

  data () {
    return {
      success: false,
      successMessage: 'Εσύ και ο φίλος σου κερδίσατε από 12GB ο καθένας. Καλό σκρολάρισμα!',
      getReward: false,
      msisdn: '',
      dialogMessage: '',
      dialog: false,
      valid: false,
      loading: false,
      msisdnRulesText:{gr: 'Παρακαλώ συμπλήρωσε τον αριθμό σου', en: 'Please fill in your phone number'},
      msisdnRulesTextReq:{gr: 'Παρακαλώ συμπλήρωσε έναν έγκυρο αριθμό', en: 'Please fill in a valid phone number'},
      msisdnRules: [
        v => !!v || this.msisdnRulesText[this.$store.getters.getLocale],
        v => /^\d{10}$/.test(v) || this.msisdnRulesTextReq[this.$store.getters.getLocale]
      ],
      pushes: 0,
    }
  },
  mounted () {
  },
  computed: {
    contentList() {
      return this.$store.getters.getRafContentList
    },
    getMessages () {
      return this.$store.getters.getMessages
    }
  },
  methods: {
    ...mapGetters([
      'getRafContentList'
    ]),
    orderCard () {
      // TODO: add redirect url
      window.location.href = ''
    },
    openUrl (url) {
      window.open(url, '_blank')
    },
    goToReward(){
      this.getReward = true
      this.pushes += 1
    },
    finalizeInvitation(){
      this.loading = true
      this.dialogMessage = ''
      this.$store.commit('setMsisdn', this.msisdn);
      axios.post('/apiv2/referafriend/finalizeInvitation', {
        "caller": {
            "callingSystem":"myQweb",
            "salesCode":"",
            "username":"username",
            "data":"",
            "locale":this.$store.getters.getFullLocale,
            "channel":"Q"
        },
        "referrerMsisdn": this.$store.getters.getRefMsisdn,
        "referralMsisdn": this.msisdn,
        // "acceptanceId": this.$store.getters.getAcceptanceId
        "acceptanceId": document.cookie.split("rafAcceptanceId=")[1].split(";")[0]
      }).then(response => {
        if (response.data.errorMessage) {
          this.dialogMessage = response.data.errorMessage;
          // handleDataLayer.init();
          // handleDataLayer.pushRafDataLayer({
          //   "event" : {
          //     "initiator": "friend-matching",
          //     "emailVerified": false,
          //     "segment": "12Gbfor12months",
          //     "finalized": false
          //   }
          // })
        }
        if (response.data.success) {
          this.success = true;
          this.successMessage = response.data.successMessage;
          handleDataLayer.init();
          handleDataLayer.pushRafDataLayer({
            "event" : {
              "initiator": "friend-matching",
              "emailVerified": true,
              "segment": this.contentList.segmentId,
              "finalized": true
            }
          })
        }
      }).catch(error => {
        if (error.response.data.errorMessage) {
          this.dialogMessage = error.response.data.errorMessage;
        }
        else{
          this.$store.getters.getLocale === 'gr' ? this.dialogMessage = 'Υπήρξε κάποιο πρόβλημα. Παρακαλώ προσπαθήστε ξανά αργότερα.' : this.dialogMessage = 'There was an error. Please try again later.'
        }
      }).finally(() => {
        this.loading = false;
      });
    }
  }
};
</script>
